export var AccessTokenDefaultExpiryTimeInMs = 3600000;
// End of copied content
var CommonUtil = /** @class */ (function () {
    function CommonUtil() {
    }
    CommonUtil.GetCookies = function () {
        return document.cookie
            .split('; ')
            .map(function (result) { return result.split('='); })
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return ({ key: decodeURIComponent(key), value: decodeURIComponent(value) });
        });
    };
    // Take from 'Website\Areas\Home\Content\js\utilities\guid-generator.utility.ts'
    CommonUtil.CreateGuid = function () {
        var timestamp = window.performance.now();
        var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
            // tslint:disable-next-line:no-bitwise
            var rand = (timestamp + Math.random() * 16) % 16 | 0;
            timestamp = Math.floor(timestamp / 16);
            // tslint:disable-next-line:no-bitwise
            return (char === 'x' ? rand : (rand & 0x3 | 0x8)).toString(16);
        });
        return guid;
    };
    CommonUtil.InitializeCIDSID = function (sidCookieName, sidCookiePath) {
        if (!sidCookieName) {
            return;
        }
        // Initialize correlation id
        var cidParam = CommonUtil.GetQueryParam(new URL(window.location.href), 'cid');
        window.overrideCID = cidParam || CommonUtil.CreateGuid();
        // Initialize session id
        var pair = CommonUtil.GetCookies().find(function (cookiePair) { return cookiePair.key === sidCookieName; });
        if (pair) {
            window.overrideSID = pair.value;
        }
        else {
            window.overrideSID = CommonUtil.CreateGuid();
            var cookiePath = sidCookiePath ? ";path=" + sidCookiePath : '';
            document.cookie = sidCookieName + "=" + encodeURIComponent(window.overrideSID) + cookiePath;
        }
    };
    CommonUtil.NotifyInstallingWorkerAppFailed = function (registration, unregister) {
        if (unregister === void 0) { unregister = false; }
        if (!registration) {
            return;
        }
        var notifyWorker = function () {
            var payload = {
                success: false,
                unregister: unregister
            };
            var message = {
                type: 'OFFICECOM_LOAD_COMPLETE',
                meta: 'installation-app',
                payload: payload
            };
            registration.installing.postMessage(message);
            registration.removeEventListener('updatefound', notifyWorker);
        };
        if (registration.installing) {
            notifyWorker();
        }
        else {
            // We want to wait for the current installation to begin, but future updates shouldn't be sent this message
            registration.addEventListener('updatefound', notifyWorker);
            setTimeout(function () { registration.removeEventListener('updatefound', notifyWorker); }, 5000);
        }
    };
    CommonUtil.SetQueryParam = function (url, paramName, paramValue) {
        if (!url || !paramName || !paramValue) {
            return;
        }
        if (typeof URLSearchParams !== 'undefined') {
            url.searchParams.set(paramName, paramValue);
            return;
        }
        var search = url.search;
        if (!search || search.length < 2) {
            url.search = "?" + paramName + "=" + paramValue;
            return;
        }
        var params = search.substring(1).split('&');
        var i;
        for (i = 0; i < params.length; i++) {
            var name_1 = params[i].split('=')[0];
            if (name_1 === paramName) {
                params[i] = name_1 + "=" + paramValue;
                break;
            }
        }
        if (i === params.length) {
            params.push(paramName + "=" + paramValue);
        }
        url.search = "?" + params.join('&');
    };
    CommonUtil.GetQueryParam = function (url, paramName) {
        if (!url || !paramName) {
            return '';
        }
        if (typeof URLSearchParams !== 'undefined') {
            return url.searchParams.get(paramName);
        }
        var search = url.search;
        if (!search || search.length < 2) {
            return '';
        }
        var params = search.substring(1).split('&');
        for (var i = 0; i < params.length; i++) {
            var _a = params[i].split('='), name_2 = _a[0], value = _a[1];
            if (name_2 === paramName) {
                return value;
            }
        }
        return '';
    };
    return CommonUtil;
}());
export { CommonUtil };
var LoggingUtil = /** @class */ (function () {
    function LoggingUtil() {
    }
    LoggingUtil.CurrentTime = function () {
        return LoggingUtil.PerformanceLoggingEnabled ? performance.now() : new Date().getTime();
    };
    // Attempts to log an event to Aria by first checking if instrumentationService or standalone logger exist
    // If so, it logs the event, if not, it queues the event to be logged when one of them does initialize
    LoggingUtil.LogEvent = function (streamName, eventName, securityThreshold, eventParams, metrics) {
        eventParams = eventParams || {};
        metrics = metrics || [];
        if (window.instrumentationService) {
            window.instrumentationService.generateEvent(eventName, streamName, securityThreshold, eventParams, metrics, true);
            return;
        }
        if (LoggingUtil.StandaloneLoggerRunning) {
            StandaloneAriaLogger.Logger.LogEvent(streamName, eventName, eventParams, securityThreshold);
            return;
        }
        if (!window.queuedEvents) {
            window.queuedEvents = [];
        }
        var ariaEvent = {
            streamName: streamName,
            eventName: eventName,
            eventParams: eventParams,
            metrics: metrics,
            securityThreshold: securityThreshold
        };
        window.queuedEvents.push(ariaEvent);
    };
    // Add performance marker either by angular PerformanceService if exists, or via queuedMarks which will be measured later
    LoggingUtil.MarkPerformance = function (mark, measureFrom, eventSecurityLevel, globalSecuritySetting, eventParams) {
        if (!LoggingUtil.PerformanceLoggingEnabled || eventSecurityLevel > globalSecuritySetting || !mark) {
            return;
        }
        if (window.performanceService) {
            window.performanceService.mark(mark, measureFrom, 0 /* Security */);
            return;
        }
        window.performance.mark(mark);
        if (!window.queuedMarks) {
            window.queuedMarks = [];
        }
        var appMark = {
            markName: mark,
            measureFrom: measureFrom,
            eventParams: eventParams
        };
        window.queuedMarks.push(appMark);
        // If we've already dumped markers, then immediately generate event for new mark since we assume app will never load
        if (LoggingUtil.DrainOnMark) {
            LoggingUtil.GeneratePerformanceEvents(false);
        }
    };
    /* Call this method to force all events in window.queuedEvents to be sent to an Aria logger.
    * If window.instrumentationService or standalone logger already exist, the events will have already been sent when it initailized.
    * If not, then we need to initialize the standalone logger, which will log queued events.
    * Passing teardown=true param will force all logs to be flushed to Aria immediately, as would be desired before navigation.
    */
    LoggingUtil.FlushQueuedEvents = function (contextPromise, teardown, page) {
        LoggingUtil.GeneratePerformanceEvents(teardown, page);
        if (window.instrumentationService || LoggingUtil.StandaloneLoggerRunning) {
            // If instrumentationService or standalone are initialized, then we've already sent queued events to aria logger
            // If teardown is requested we will flush, otherwise the logs will be sent naturally
            if (teardown) {
                window.instrumentationService ? window.instrumentationService.flush() : StandaloneAriaLogger.Logger.EndSession(true, true);
            }
            return Promise.resolve(true);
        }
        return contextPromise.then(function (context) {
            if (typeof StandaloneAriaLogger === 'undefined' || !StandaloneAriaLogger.Logger) {
                return Promise.reject('Standalone aria logger does not exist');
            }
            // Note: StandaloneAriaLogger.Logger.Initialize() will log queued events
            StandaloneAriaLogger.Logger.Initialize(context, false);
            if (teardown) {
                StandaloneAriaLogger.Logger.EndSession(true, true);
            }
            LoggingUtil.StandaloneLoggerRunning = true;
            return Promise.resolve(true);
        }).catch(function (error) {
            console.log(error);
            return Promise.resolve(false);
        });
    };
    // Call this method to stop using standalone logger if we think there's a chance angular will take over
    // Currently only used when user logs in from pwa unauth page
    LoggingUtil.RevokeStandaloneLogger = function () {
        if (LoggingUtil.StandaloneLoggerRunning) {
            StandaloneAriaLogger.Logger.EndSession(true, false);
            LoggingUtil.StandaloneLoggerRunning = false;
            LoggingUtil.DrainOnMark = false;
        }
    };
    // Generate performance events from queuedMarks and browser timing entries when performanceService is not available.
    // Intended to be used in cases where angular app is not available, but performance metrics must be logged.
    // This code is copied and adapted in bootstrap-handler.ts
    // TODO: Refactor to share generation of queuedEvents from queuedMarks in app and inline bundle
    // Start of copied content
    LoggingUtil.GeneratePerformanceEvents = function (flushBrowserMarks, page) {
        LoggingUtil.DrainOnMark = true;
        if (!LoggingUtil.PerformanceLoggingEnabled || window.performanceService) {
            return;
        }
        var logPerfEvent = function (name, duration, params) {
            var _a;
            params = params || {};
            params['Latency'] = duration.toString();
            params['ItemCategory'] = (_a = params['ItemCategory']) !== null && _a !== void 0 ? _a : 'Inline';
            LoggingUtil.LogEvent(LoggingUtil.PerformanceDump, name, 0 /* Security */, params, []);
        };
        var logPerfError = function (errorName, errorDetails, params) {
            var _a;
            params = params || {};
            params['Error'] = errorName;
            params['DebugInfo'] = errorDetails;
            params['ItemCategory'] = (_a = params['ItemCategory']) !== null && _a !== void 0 ? _a : 'Inline';
            LoggingUtil.LogEvent(LoggingUtil.GenericEvent, LoggingUtil.PerformanceMarkFailure, 0 /* Security */, params, []);
        };
        if (window.queuedMarks) {
            window.queuedMarks.splice(0, window.queuedMarks.length).forEach(function (mark) {
                var startMark = mark.measureFrom || 'navigationStart';
                // BUGBUG: The following call may throw exception in case startMark value is deemed to be invalid. This seem to
                // primarily happen on Edge/IE and Firefox. Wrapping into try/catch so we have direct way of checking how often it happens.
                // Consider removing try/catch in case this is no longer happening.
                try {
                    window.performance.measure(mark.markName, startMark, mark.markName);
                }
                catch (ex) {
                    logPerfError(mark.markName, "Failed to record <" + mark.markName + "> starting from <" + startMark + ">: exception is thrown", mark.eventParams);
                    return;
                }
                var appMeasures = window.performance.getEntriesByName(mark.markName, 'measure');
                if (!appMeasures || !appMeasures.length) {
                    logPerfError(mark.markName, "Failed to record <" + mark.markName + ">: measure missing", mark.eventParams);
                    return;
                }
                var timingEntry = appMeasures[0];
                var duration = Math.ceil(timingEntry.duration);
                logPerfEvent(mark.markName, duration, mark.eventParams);
            });
        }
        // If immediate flush isn't required we want to wait for document to complete loading before logging browser timing
        if (!flushBrowserMarks && document.readyState !== 'complete') {
            window.addEventListener('load', function () {
                LoggingUtil.GeneratePerformanceEvents(true, page);
            });
            return;
        }
        // Only log browser measures once
        if (LoggingUtil.BrowserMeasuresLogged) {
            return;
        }
        LoggingUtil.BrowserMeasuresLogged = true;
        var browserMeasures = LoggingUtil.GetBrowserTimingMeasures(function (name, error) {
            logPerfError(name, error, { Page: page });
        });
        browserMeasures.forEach(function (measure) {
            logPerfEvent(measure.name, measure.duration, { Page: page });
        });
    };
    LoggingUtil.PerformanceLoggingSupported = function () {
        var performance = window.performance;
        return !!(performance && performance.now && performance.mark && performance.timing && performance.timing.navigationStart && performance.measure && performance.getEntriesByType);
    };
    LoggingUtil.GetBrowserTimingMeasures = function (handleError, commonParams, onMeasureAdded) {
        var dump = new Array();
        if (!LoggingUtil.PerformanceLoggingSupported()) {
            return dump;
        }
        // Add all the browser timing info (see http://www.w3.org/TR/navigation-timing/#processing-model)
        // ReSharper disable once MissingHasOwnPropertyInForeach
        for (var marker in window.performance.timing) {
            // Limit only to browser markers that we are interested in
            var relativeMarker = LoggingUtil.globalAllowedMarkers.get(marker);
            if (!relativeMarker) {
                continue;
            }
            var value = window.performance.timing[marker];
            var relativeValue = window.performance.timing[relativeMarker];
            // Do not record measure when value for marker and/or relative marker is not a number, indicating some sort of bad state of performance.timing
            if (typeof value !== 'number' || typeof relativeValue !== 'number') {
                handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to unexpected value type: <" + marker + "> value type is " + typeof value + "; <" + relativeMarker + "> value type is " + typeof relativeValue);
                continue;
            }
            // Do not record measure when value for marker and/or relative marker is '0', indicating that corresponding moment never happened
            if (value === 0 || relativeValue === 0) {
                // Unload markers are expected to have zero value when it was fresh page load or unloaded page was from different domain
                if (marker !== "unloadEventStart" /* UnloadEventStart */ && marker !== "unloadEventEnd" /* UnloadEventEnd */) {
                    handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to unexpected zero values: <" + marker + ">=" + value + "; <" + relativeMarker + ">=" + relativeValue);
                }
                continue;
            }
            // Marker value should not be less than the one recorded for relative marker
            if (value < relativeValue) {
                handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to relative marker value being greater than marker value: <" + marker + ">=" + value + "; diff from <" + relativeMarker + ">=" + (value - relativeValue));
                continue;
            }
            // All marker values must be greater or equal to navigationStart
            if (value < window.performance.timing.navigationStart) {
                handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to marker value being less than <navigationStart> marker value: <" + marker + ">=" + value + "; diff from <navigationStart}>=" + (value - window.performance.timing.navigationStart));
                continue;
            }
            if (relativeValue < window.performance.timing.navigationStart) {
                handleError(marker, "Failed to calculate measure for <" + marker + "> starting from <" + relativeMarker + "> due to relative marker value being less than <navigationStart> marker value: <" + marker + ">=" + value + "; <" + relativeMarker + ">=" + relativeValue + "; diff from <navigationStart}>=" + (relativeValue - window.performance.timing.navigationStart));
                continue;
            }
            var duration = Math.ceil(value - relativeValue);
            dump.push({ name: marker, duration: duration, params: !commonParams ? {} : Object.assign({}, commonParams) });
            // In older versions of Firefox (<= 52) if the measure name provided to
            // performance.measure() is a known browser marker name (like 'navigationStart' etc),
            // a "illegal string" error is thrown. This suffix is added to all measure names to avoid
            // this exception. performance_dump entries will not have this prefix, but it will show up
            // in the browser's performance measure viewer.
            var measureName = marker + "_ohp_measure";
            if (onMeasureAdded) {
                onMeasureAdded(marker, measureName);
            }
            // Record measure so it shows up in Dev tools
            // BUGBUG: The following call may fail on older version of Firefox browsers when Firefox deem start and/or marker values to be invalid.
            // Wrapping into try/catch so we have direct way of checking how often it happens. Consider removing try/catch in case this is no longer happening.
            try {
                window.performance.measure(measureName, relativeMarker, marker);
            }
            catch (ex) {
                handleError(marker, "Failed to record measure for <" + marker + "> starting from <" + relativeMarker + ">: exception is thrown");
            }
        }
        return dump;
    };
    LoggingUtil.PerformanceLoggingEnabled = LoggingUtil.PerformanceLoggingSupported();
    LoggingUtil.DrainOnMark = false;
    LoggingUtil.BrowserMeasuresLogged = false;
    LoggingUtil.StandaloneLoggerRunning = false;
    // These values are copied from instrumentation.service.ts
    LoggingUtil.GenericDebugCache = 'Generic_Debug_Cache_2';
    LoggingUtil.GenericClick = 'Generic_Click';
    LoggingUtil.GenericEvent = 'Generic_Event';
    LoggingUtil.GenericRequest = 'Generic_Request';
    LoggingUtil.PerformanceDump = 'Performance_Dump';
    LoggingUtil.PerformanceMarkFailure = 'Performance_Mark_Failure';
    LoggingUtil.EmailRegex = new RegExp('[a-zA-Z0-9_\\-\\.]+(@|%40|%2540)[a-zA-Z0-9_\\-\\.]+\\.[a-zA-Z]{2,63}', 'gm');
    // End of copied content
    // Below code is copied and adapted from performance.service.ts
    // TODO: Refactor to allow code sharing between inline files and angular app
    // Start of copied content
    LoggingUtil.globalAllowedMarkers = new Map([
        ["fetchStart" /* FetchStart */, "navigationStart" /* NavigationStart */],
        ["unloadEventStart" /* UnloadEventStart */, "navigationStart" /* NavigationStart */],
        ["unloadEventEnd" /* UnloadEventEnd */, "unloadEventStart" /* UnloadEventStart */],
        ["domainLookupEnd" /* DomainLookupEnd */, "domainLookupStart" /* DomainLookupStart */],
        ["connectEnd" /* ConnectEnd */, "connectStart" /* ConnectStart */],
        ["requestStart" /* RequestStart */, "navigationStart" /* NavigationStart */],
        ["responseStart" /* ResponseStart */, "requestStart" /* RequestStart */],
        ["responseEnd" /* ResponseEnd */, "responseStart" /* ResponseStart */],
        ["domLoading" /* DomLoading */, "responseStart" /* ResponseStart */],
        ["domInteractive" /* DomInteractive */, "domLoading" /* DomLoading */],
        ["domComplete" /* DomComplete */, "domLoading" /* DomLoading */]
    ]);
    return LoggingUtil;
}());
export { LoggingUtil };
var BootstrapUtil = /** @class */ (function () {
    function BootstrapUtil() {
    }
    BootstrapUtil.InitDiskPreload = function (userId, diskPreloadRequestMap, diskPreloadStorageKey) {
        // If a page has a Service Worker, try to load all Service Worker data into memory in the inline
        // script, so it will be available by the time the main bundle is parsed and executed.
        var hasServiceWorkerApi = window.navigator.serviceWorker && window.navigator.serviceWorker.controller;
        if (userId && hasServiceWorkerApi && diskPreloadRequestMap) {
            var diskPreloadUrls = [];
            var stringifiedDiskPreloadStorageEntries = localStorage.getItem(diskPreloadStorageKey);
            if (stringifiedDiskPreloadStorageEntries) {
                diskPreloadUrls = JSON.parse(stringifiedDiskPreloadStorageEntries);
            }
            diskPreloadUrls.forEach(function (entry) {
                var url = entry.url, markerName = entry.markerName;
                if (!url || !markerName) {
                    return;
                }
                var headers = new Headers();
                headers.append('X-SW-OHP-FetchStrategy', 'cache-only');
                headers.append('X-SW-OHP-UserCacheId', userId);
                var request = new Request(url, { headers: headers });
                var diskPreloadStartMarker = "Disk_Preload_Start_" + markerName;
                LoggingUtil.MarkPerformance(diskPreloadStartMarker, '', 0 /* Security */, 3 /* Full */);
                var responsePromise = fetch(request).catch(function () { return Response.error(); });
                responsePromise.then(function () {
                    var diskPreloadEndMarker = "Disk_Preload_End_" + markerName;
                    LoggingUtil.MarkPerformance(diskPreloadEndMarker, diskPreloadStartMarker, 0 /* Security */, 3 /* Full */);
                });
                diskPreloadRequestMap.set(url, responsePromise);
            });
        }
    };
    return BootstrapUtil;
}());
export { BootstrapUtil };
var PrefetchData = /** @class */ (function () {
    function PrefetchData() {
    }
    PrefetchData.prefetchMruData = function (token, inMock, useS2S, locale, buildId, workload, userId, mockValue) {
        var currentUrl = new URL(window.location.href);
        var serviceBaseUrl = '';
        if (useS2S) {
            var s2sPath = 'api/mru';
            serviceBaseUrl = currentUrl.origin + "/" + (inMock ? "mock" /* mockApiRoot */ + '/' + s2sPath : s2sPath);
        }
        else {
            serviceBaseUrl = inMock ? currentUrl.origin + "/" + "mock" /* mockApiRoot */ + "/" + "v2/recent" /* MruPath */ + "/" + "docs" /* MruDocPath */ : "https://ocws.officeapps.live.com/ocs" /* ServiceRoot */ + "/" + "v2/recent" /* MruPath */ + "/" + "docs" /* MruDocPath */;
        }
        var mruSupportedFileTypes = "Word,Excel,PowerPoint,Visio,OneNote,Sway,Project,Portfolio,Forms,PdfViewer,PowerBI" /* SupportedFileTypes */;
        // IMPORTANT: Make sure Query String parameters values and order are in-sync with what our Angular app.
        // Otherwise, SW will fail to update the correct cache entry.
        // TODO: remove size param when fully on S2S flow.
        var mruUrl = new URL(serviceBaseUrl + "?" + "apps=" /* AppSpecifier */ + mruSupportedFileTypes + "&" + "show=" /* SizeSpecifier */ + 100 /* MruNumItemsToRequest */ + "&" + "rs=" /* LocaleSpecifier */ + locale + (useS2S ? '&workload=' + workload : ''));
        var headers = new Headers();
        if (!useS2S) {
            headers.append('X-CorrelationId', window.overrideCID);
            headers.append('X-Office-Platform', 'Web');
            headers.append('X-Office-Application', 109 /* IceApplicationId */.toString());
            headers.append('X-Office-Version', buildId);
        }
        if (token) {
            headers.append('Authorization', "Bearer " + token.token);
        }
        if (userId) {
            this.addCacheHeaders(headers, userId);
        }
        if (mockValue) {
            headers.append('ohp-mock', mockValue);
        }
        var mruData = {
            method: 'GET',
            headers: headers,
            credentials: 'include'
        };
        var mruDataRequest = new Request(mruUrl.toString(), mruData);
        var mruDataPromise = fetch(mruDataRequest);
        return mruDataPromise;
    };
    PrefetchData.prefetchRecommendedData = function (token, inMock, useFeed, locale, clientId, tenantId, oid, userId, mockValue, requestId) {
        var currentUrl = new URL(window.location.href);
        var serviceBaseUrl = '';
        var recommendedUrl = new URL(window.location.href);
        var headers = new Headers();
        headers.append('client-request-id', requestId);
        headers.append('X-Office-Application', 114 /* RecommendedIceApplicationId */.toString());
        // IMPORTANT: Make sure Query String parameters values and order are in-sync with what our Angular app.
        // Otherwise, SW will fail to update the correct cache entry.
        if (!useFeed) {
            var recommendedSupportedFileTypes = "Word,Excel,PowerPoint,OneNote,Pdf,Visio" /* SupportedFileTypes */;
            serviceBaseUrl = inMock ? currentUrl.origin + "/" + "mock" /* mockApiRoot */ + "/" + "recommended/api/v1.0" /* RecommendedB2ApiRootPath */ : "https://substrate.office.com" /* SubstrateApiEndpoint */ + "/" + "recommended/api/v1.0" /* RecommendedB2ApiRootPath */;
            recommendedUrl = new URL(serviceBaseUrl + "/" + "files" /* RecommendedB2ApiFilesPath */ + "?" + "show=" /* SizeSpecifier */ + 16 /* NumRecommendedToRequest */ + "&" + "skipCache=false" /* SkipCacheParam */ + "&" + "apps=" /* AppSpecifier */ + recommendedSupportedFileTypes + "&" + "rs=" /* LocaleSpecifier */ + locale);
            headers.append('X-Ms-ClientAppId', clientId);
            headers.append('X-AnchorMailbox', oid + "@" + tenantId);
            headers.append('X-RoutingParameter-SessionKey', oid);
        }
        else {
            serviceBaseUrl = inMock ? currentUrl.origin + "/" + "mock" /* mockApiRoot */ + "/" + "PeoplePredictionsB2/MicrosoftFeed" /* RecommendedFeedApiRootPath */ : "https://substrate.office.com" /* SubstrateApiEndpoint */ + "/" + "PeoplePredictionsB2/MicrosoftFeed" /* RecommendedFeedApiRootPath */;
            recommendedUrl = new URL(serviceBaseUrl + "?section=" + "OfficeComHome" /* Section */ + "&scenario=" + "OfficeComANTP" /* Scenario */ + "&" + "rs=" /* LocaleSpecifier */ + locale);
            headers.append('scenariotag', "OfficeComANTP" /* ScenarioTag */);
            headers.append('x-officefeedflight', "evaluation" /* Officefeedflight */);
        }
        if (token) {
            headers.append('Authorization', "Bearer " + token.token);
        }
        if (userId) {
            this.addCacheHeaders(headers, userId);
        }
        if (mockValue) {
            headers.append('ohp-mock', mockValue);
        }
        var recommendedData = {
            method: 'GET',
            headers: headers,
            cache: 'default',
            credentials: 'include'
        };
        var recommendedDataRequest = new Request(recommendedUrl.toString(), recommendedData);
        var recommendedDataPromise = fetch(recommendedDataRequest);
        return recommendedDataPromise;
    };
    PrefetchData.prefetchSharePointSitesData = function (token, inMock, lcid, buildId, userId, mockValue) {
        var currentUrl = new URL(window.location.href);
        var sitesServiceUrl = inMock
            ? currentUrl.origin + "/" + "mock" /* mockApiRoot */ + "/" + "sites" /* SharepointPath */
            : "https://odc.officeapps.live.com/odc/servicemanager/v2.0" /* SharePointServiceRoot */ + "/" + "sites" /* SharepointPath */ + "?lcid=" + lcid + "&uilcid=" + lcid + "&syslcid=" + lcid + "&lists=frequent,followed&items=" + 12 /* MaxTotalListItems */;
        // IMPORTANT: Make sure Query String parameters values and order are in-sync with what our Angular app.
        // Otherwise, SW will fail to update the correct cache entry.
        var sitesUrl = new URL(sitesServiceUrl);
        var headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('X-CorrelationId', window.overrideCID);
        headers.append('X-Office-Platform', 'Web');
        headers.append('X-Office-Application', 109 /* IceApplicationId */.toString());
        headers.append('X-Office-Version', buildId);
        if (token) {
            headers.append('Authorization', "Bearer " + token.token);
        }
        if (userId) {
            this.addCacheHeaders(headers, userId);
        }
        if (mockValue) {
            headers.append('ohp-mock', mockValue);
        }
        var sharePointSitesData = {
            method: 'GET',
            headers: headers,
            cache: 'default'
        };
        var sharePointSitesDataRequest = new Request(sitesUrl.toString(), sharePointSitesData);
        var sharePointSitesDataPromise = fetch(sharePointSitesDataRequest);
        return sharePointSitesDataPromise;
    };
    PrefetchData.addCacheHeaders = function (headers, userId) {
        var hasServiceWorkerApi = 'serviceWorker' in window.navigator;
        if (!hasServiceWorkerApi) {
            return;
        }
        var hasController = !!window.navigator.serviceWorker.controller;
        var isOnline = window.navigator.onLine;
        // This enables writing into Service Worker cache, while still using the network data.
        if (hasController && isOnline && userId) {
            headers.append('X-SW-OHP-FetchStrategy', 'network-first');
            headers.append('X-SW-OHP-UserCacheId', userId);
        }
    };
    return PrefetchData;
}());
export { PrefetchData };
